import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Renderer2 } from '@angular/core';
import { map } from 'rxjs/operators';
import { ApiResponse } from 'src/app/model/apiResponse.model';
import { ApiProviderService } from 'src/app/services/api-provider.service';

@Injectable({
  providedIn: 'root'
})
export class CustomScriptInjectionService {

  headers: HttpHeaders;
  apiServer: string;

  private trackedLinks = new Array<HTMLLinkElement>();
  private trackedScripts = new Array<HTMLScriptElement>();

  constructor(private http: HttpClient, private apiRef: ApiProviderService) {
    this.headers = new HttpHeaders();
    this.headers.append('Content-Type', 'application/json');
    this.headers.append('Accept', 'application/json');
    this.apiServer = 'api/customizedcode/';
  }

  loadAndRunCustomScriptBlock(renderer: Renderer2, doc: Document, route: string) {

    return this.http.get<ApiResponse>(this.apiRef.getApiUrl(`${this.apiServer}links`,
    [{Key: 'routeName', Value:route}]))
     .pipe(map((res) => {
        if(res.result){
          const links = res.result as string[];
          links.forEach((r)=>{
            if(r.endsWith('css')){
              const cssSrcUrl = this.apiRef.getCustomizationUrl(r);
              const c = doc.createElement('link');
              c.rel = 'stylesheet';
              c.type = 'text/css';
              c.id = r + 'style';
              c.href = cssSrcUrl;
              this.trackedLinks.push(c);
              renderer.appendChild(doc.body, c);
            } else {
              const jsSrcUrl = this.apiRef.getCustomizationUrl(r);
              const s = doc.createElement('script');
              s.type = 'text/javascript';
              s.id = r+'js';
              s.src = jsSrcUrl;
              this.trackedScripts.push(s);
              renderer.appendChild(doc.body, s);
            }
          });
        }

      }))
     .subscribe();

  }

  removeTrackedElements() {
    this.trackedLinks.forEach(link => link.remove());
    this.trackedScripts.forEach(s => s.remove());
  }

}
